import { IonIcon, IonList } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { chevronForwardOutline } from "ionicons/icons";
import { DiscoverRow } from "@/components/molecules/project/discover-row";
import { type ForYouMatch } from "@/lib/discover-for-you";

/**
 * Het zetje op Vandaag: werk waarop je je kunt aanmelden.
 *
 * Staat bewust bóven "Daarna" en niet eronder. Daarna is een lijst van kaarten; wat daaronder komt
 * scrollt weg en bestaat daarmee niet. Boven je volgende dienst hoort het óók niet — dat is het
 * antwoord op "wanneer werk ik", en dáárvoor openen mensen deze app.
 *
 * Niets als er geen match is. Een lege "voor jou" zegt dat de app naar je gekeken heeft en niets
 * gevonden — onwaar zodra er morgen wel iets is, en onaangenaam vandaag.
 *
 * De rijen zijn dezelfde `DiscoverRow` als op Ontdek, inclusief de regel die zegt wáárom hij er
 * staat. Dat is de hele afspraak: twee harde regels, opgeschreven, zodat niemand hoeft te raden wat
 * de app over hem besloten heeft.
 */
export function ForYouNudge({
  matches,
  onSeeAll,
}: {
  matches: ForYouMatch[];
  onSeeAll: () => void;
}) {
  const { t } = useTranslation();

  if (matches.length === 0) {
    return null;
  }

  return (
    <section className="flex flex-col gap-3">
      <div className="flex flex-col gap-0.5">
        <h2 className="text-xs font-bold uppercase tracking-wide text-txt-secondary">
          {t("routes:today.for-you.title")}
        </h2>
        <p className="text-xs text-txt-tertiary">{t("routes:today.for-you.hint")}</p>
      </div>

      <IonList className="flex flex-col">
        {matches.map(({ card, reason }) => (
          <DiscoverRow
            key={`today-for-you-${card.projectId}-${card.day}`}
            card={card}
            showDay
            note={t(`common:discover.for-you.reason.${reason}`)}
          />
        ))}
      </IonList>

      <button
        type="button"
        onClick={onSeeAll}
        className="flex items-center gap-1 self-start text-sm font-semibold text-txt-brand"
      >
        {t("routes:today.for-you.cta")}
        <IonIcon icon={chevronForwardOutline} className="size-4" />
      </button>
    </section>
  );
}
